const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/route.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { parseAppIdParams, stringifyAppIdParams, validateAppIdBeforeLoad } from '@apps/main/features/user/components/layout/app-detail-utils';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId')({
  params: {
    parse: parseAppIdParams,
    stringify: stringifyAppIdParams
  },
  beforeLoad: validateAppIdBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});